import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiTypography-h3': {
      maxWidth: '340px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis'
    },
    '& .MuiTypography-h5': {
      marginLeft: '10px'
    }
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  rightButton: {
    '& + &': {
      marginLeft: '10px'
    }
  },
  footerWrapper: {
    display: 'flex',
    marginTop: '10px',
    padding: '26px 40px',
    borderTop: "1px solid ".concat(palette.shades[400]),
    justifyContent: 'flex-end',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  form: {
    height: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  formContent: {
    padding: '32px 40px',
    overflowY: 'auto',
    flexGrow: '1'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    '& img': {
      marginLeft: '4px'
    }
  },
  changePayment: {
    marginTop: '18px'
  },
  searchWrapper: {
    flexGrow: '1',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      marginRight: '0',
      marginBottom: '24px'
    }
  },
  filterMultiselectContainer: {
    maxHeight: '340px',
    overflowY: 'scroll',
    overflowX: 'hidden'
    // boxShadow: 'inset 0px -7px 20px -15px rgba(66, 68, 90, 0.65)',
  }
}));
export default useStyles;